import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import UploadFile from '@/shared/services/oss.service';
@Component({
    components: {},
})
export default class AddResumeEnclosureInfo extends Vue {
    @Prop() data: any; // 附件信息
    @Prop() inResume: any; // 是否在录用简历中
    fileLimit: any = { fileType: '*', fileLength: 10, fileSize: 5 }; // 附件限制
    fileUrlList: any = []; // 附件List
    enclosureForm: any = { // 表单信息
        EnclosureList: [],
    };
    enclosureRules: any = { // 表单验证
        EnclosureList: [
            { required: true, message: '请上传简历附件或个人作品集', trigger: ['blur', 'change'] }
        ],
    };

    created() {
        // 附件获取
        if (this.data && this.data.files) {
            this.enclosureForm.EnclosureList = this.data.files;
        }
    }

    // 监听简历信息变化
    @Watch('data')
    onDataChanged(val: any, oldVal: any) {
        if (val.files && val.files.length > 0) {
            this.enclosureForm.EnclosureList = val.files;
        }
    }

    // 上传简历附件
    beforeFileUpload(file: any) {
        if (this.enclosureForm.EnclosureList.length >= this.fileLimit.fileLength) {
            this.$message({
                message: '最多可添加' + this.fileLimit.fileLength + '个',
                type: 'warning'
            });
            return false;
        }
        UploadFile.addFileAliyun(file.file).then(
            (res: any) => {
                this.fileUrlList.push(res.url);
                const fileItem = {
                    fileUrl: res.url,
                    name: file.file.name
                }
                this.enclosureForm.EnclosureList.push(fileItem);
                (this as any).$refs["enclosureForm"].validate();
            }
        )
        return false;
    }

    // 删除附件
    deleteFile(index: any) {
        this.enclosureForm.EnclosureList.splice(index, 1);
        (this as any).$refs["enclosureForm"].validate()
    }

    // 上一步
    goBack() {
        const data = {
            currentStep: 4,
            move: 'back',
        };
        this.$emit('getRecruitInfo', data);
    }

    // 下一步
    goNext(formName: any) {
        (this as any).$refs[formName].validate((valid: any) => {
            if (valid) {
                const data = {
                    currentStep: 4,
                    move: 'next',
                    fromInfo: this.enclosureForm.EnclosureList,
                };
                this.$emit('getRecruitInfo', data);
            } else {
                return false;
            }
        });
    }
}
